import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { TemplateEditorView } from '@/features/contract-management/components/TemplateEditorView';

export const Route = createFileRoute('/_authenticated/contract-management/templates/$id')({
  component: TemplateEditRoute,
});

function TemplateEditRoute() {
  const { id } = Route.useParams();
  const navigate = useNavigate();

  return (
    <TemplateEditorView
      mode="edit"
      templateId={id}
      onBack={() => navigate({ to: '/contract-management' })}
    />
  );
}
